import { defineComponent as _defineComponent } from 'vue';
import { faEdit, faSitemap, faUpload } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BAlert, BButton, BButtonGroup } from "bootstrap-vue";
import { storeToRefs } from "pinia";
import { computed, ref } from "vue";
import { RouterLink } from "vue-router";
import { isRegisteredUser } from "@/api";
import { useWorkflowInstance } from "@/composables/useWorkflowInstance";
import { useUserStore } from "@/stores/userStore";
import localize from "@/utils/localization";
import { errorMessageAsString } from "@/utils/simple-error";
import { copyWorkflow } from "./workflows.services";
import AsyncButton from "../Common/AsyncButton.vue";
import ButtonSpinner from "../Common/ButtonSpinner.vue";
import WorkflowRunButton from "./WorkflowRunButton.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'WorkflowNavigationTitle',
    props: {
        invocation: { default: undefined },
        workflowId: null,
        runDisabled: { type: Boolean },
        runWaiting: { type: Boolean },
        success: { type: Boolean }
    },
    emits: ["on-execute"],
    setup(__props, { emit }) {
        const props = __props;
        const { workflow, error } = useWorkflowInstance(props.workflowId);
        const { currentUser, isAnonymous } = storeToRefs(useUserStore());
        const owned = computed(() => {
            if (isRegisteredUser(currentUser.value) && workflow.value) {
                return currentUser.value.username === workflow.value.owner;
            }
            else {
                return false;
            }
        });
        const importErrorMessage = ref(null);
        const importedWorkflow = ref(null);
        const workflowImportedAttempted = ref(false);
        async function onImport() {
            if (!workflow.value || !workflow.value.owner) {
                return;
            }
            try {
                const wf = await copyWorkflow(workflow.value.id, workflow.value.owner);
                importedWorkflow.value = wf;
            }
            catch (error) {
                importErrorMessage.value = errorMessageAsString(error, "Failed to import workflow");
            }
            finally {
                workflowImportedAttempted.value = true;
            }
        }
        function getWorkflowName() {
            return workflow.value?.name || "...";
        }
        const workflowImportTitle = computed(() => {
            if (isAnonymous.value) {
                return localize("Login to import this workflow");
            }
            else if (workflowImportedAttempted.value) {
                return localize("Workflow imported");
            }
            else {
                return localize("Import this workflow");
            }
        });
        return { __sfc: true, props, emit, workflow, error, currentUser, isAnonymous, owned, importErrorMessage, importedWorkflow, workflowImportedAttempted, onImport, getWorkflowName, workflowImportTitle, faEdit, faSitemap, faUpload, FontAwesomeIcon, BAlert, BButton, BButtonGroup, RouterLink, AsyncButton, ButtonSpinner, WorkflowRunButton };
    }
});
